module.exports = __webpack_public_path__ + "static/img/px.3fade1b8.svg";